<template>
    <div class="d-flex flex-row align-items-center justify-content-center py-5">
        <stamp class="animate animate--long animate--rotate primary-text"></stamp>
    </div>
</template>

<script>
    import Stamp from '../components/stamp/Stamp';

    export default {
        components: {
            Stamp,
        }
    }
</script>
